module.exports = __webpack_public_path__ + "static/media/ribbon1.39d1044d.svg";